import { Component, inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { HomeTabComponent } from '../home-tab/home-tab.component';
import { BatchesTabComponent } from '../batches-tab/batches-tab.component';
import { EarningsTabComponent } from '../earnings-tab/earnings-tab.component';
import { ProfileTabComponent } from '../profile-tab/profile-tab.component';
import { ImageModule } from 'primeng/image';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-shopper-layout',
    standalone: true,
    imports: [
        ButtonModule,
        CommonModule,
        ImageModule,
        HomeTabComponent,
        BatchesTabComponent,
        EarningsTabComponent,
        ProfileTabComponent
    ],
    templateUrl: './shopper-layout.component.html',
    styleUrl: './shopper-layout.component.scss',
    host: {
        'class': 'app-shopper-layout'
    },
    encapsulation: ViewEncapsulation.None
})
export class ShopperLayoutComponent {
  
  tabs = [
    { title: 'Home', value: 0, content: HomeTabComponent, icon: 'home' },
    { title: 'Batches', value: 1, content: BatchesTabComponent, icon: 'shopping-bag' },
    { title: 'Earnings', value: 2, content: EarningsTabComponent, icon: 'dollar' },
    { title: 'Profile', value: 3, content: ProfileTabComponent, icon: 'user' },
  ];
  selectedTab = this.tabs[0];
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.selectedTab = this.tabs.find(tab => tab.value+'' === params['tab']) || this.selectedTab;
    });
  }

  onTabChange(tab: typeof this.tabs[0]) {
    this.selectedTab = tab;
    // remove query params from url   
    this.router.navigate([], { queryParams: undefined});
  }
} 